import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import * as moment from 'moment';
import { TranslationWidth } from '@angular/common';

/**Localizes day and month names.*/
@Injectable()
export class DatePickerLocalizer extends NgbDatepickerI18n {
  @Inject(LOCALE_ID) private _locale: string;

  private _weekdaysShort: string[];
  private _monthsShort: string[];
  private _monthsLong: string[];

  constructor() {
    super();

    moment.locale(this._locale);
    const localeData = moment.localeData();

    this._weekdaysShort = localeData.weekdaysShort();
    this._weekdaysShort = this._weekdaysShort.concat(this._weekdaysShort[0]);
    this._monthsShort = localeData.monthsShort();
    this._monthsLong = localeData.months();
  }

  getWeekdayShortName(weekday: number): string {
    return this._weekdaysShort[weekday];
  }
  getMonthShortName(month: number): string {
    return this._monthsShort[month - 1];
  }
  getMonthFullName(month: number): string {
    return this._monthsLong[month - 1];
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    return 'date-picker-' + date;
  }
  getWeekdayLabel(weekday: number, width?: TranslationWidth): string {
    return this.getWeekdayShortName(weekday);
  }
}
